import styled from "@emotion/styled";
import { Box, Typography, useTheme } from "@mui/material";
import { ReactComponent as SortIcon } from "Components/_Shared/Icons/Assets/sort.svg";
import { Spacing } from "Infrastructure/Themes/Themes";
import { isPropValid } from "Infrastructure/Utils/StyleUtils";

const StyledCell = styled(Box, {
  shouldForwardProp: isPropValid,
})<{ $hasAction: boolean }>`
  cursor: ${(props) => (props.$hasAction ? "pointer" : "unset ")}
`;

type Props = {
  readonly id: string;
  readonly label?: string;
  readonly active?: boolean;
  readonly onHeaderClick?: () => void;
};

export const AnalysesTableHeaderCell: React.FC<Props> = ({ id, label, active, onHeaderClick }) => {
  const theme = useTheme();
  return (
    <StyledCell display="flex" alignItems="center" $hasAction={!!onHeaderClick}>
      <Typography variant="body2" color={active ? theme.colors.textPrimary : theme.colors.textSecondary} fontWeight={500} mr={Spacing.M}>
        {label ?? id}
      </Typography>
      {id !== "action" && onHeaderClick && <SortIcon stroke={active ? theme.colors.textPrimary : theme.colors.textSecondary} />}
    </StyledCell>
  );
};
